var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMomentum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_33814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_33814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H35V35H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_33814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6328 17.5C33.6328 26.4099 26.4099 33.6328 17.5 33.6328C8.59011 33.6328 1.36719 26.4099 1.36719 17.5C1.36719 8.59011 8.59011 1.36719 17.5 1.36719C26.4099 1.36719 33.6328 8.59011 33.6328 17.5Z",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87891 17.5C5.87891 11.0921 11.0921 5.87891 17.5 5.87891C19.1788 5.87891 20.7754 6.2367 22.218 6.88003",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 17.5C20.0977 18.9347 18.9347 20.0977 17.5 20.0977C16.0653 20.0977 14.9023 18.9347 14.9023 17.5C14.9023 16.0653 16.0653 14.9023 17.5 14.9023C18.9347 14.9023 20.0977 16.0653 20.0977 17.5Z",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6625 19.3375L12.4844 22.5156",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6923 9.30773L19.3359 15.6641",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0742 27.0703H20.926",
    stroke: "white",
    strokeWidth: 2.73437,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_33814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMomentum);
export default __webpack_public_path__ + "static/media/icon-momentum.ad0bfda5d7fc37a93be37b558271db68.svg";
export { ForwardRef as ReactComponent };